import React from "react";
import dplLogo from "../images/DPL-logo.png";

const Footer = props => {

    const openInNewTab = (url) => {
        const newWindow = window.open(url, "_blank");
        newWindow.focus();
    };


    return (<>
        <div style={{display: "flex", alignItems: "flex-start"}}>
            <div className="footerMobile footerPadding footerFixed placeholderRegularTextStyles">
                <div style={{textAlign: "left"}}>
                    <div style={{
                        display: "flex",
                        flexDirection: 'row',
                        justifyContent: 'center',
                        paddingTop: '16px',
                        alignItems: "center",
                        paddingBottom: '8px',
                    }}>

                        <div style={{paddingRight: '30px', margin: 0, textAlign: "center"}}>
                            <p>
                              Mechanical breakdown insurance is underwritten by Autosure Insurance Limited
                                <br/>
                                {/*Car insurance is provided by Vero Insurance NZ Limited and brought to you by DPL*/}
                                {/*Insurance Limited*/}
                            </p>
                          <span className='spanLink' onClick={() => {
                            window.location.hostname.includes("aa") ? window.location = "tel:0800262411" : window.location = "tel:0800267873"
                          }}>{window.location.hostname.includes("aa") ? "0800 262 411" : "0800 267 873"}</span> | <span
                          className='spanLink' onClick={() => {
                          window.location = "mailto:support@autosure.co.nz"
                        }}>support@autosure.co.nz </span>| © Autosure Insurance Limited
                            | <span className='spanLink'
                                    onClick={() => openInNewTab("https://autosure.co.nz/privacy-policy/")}>Privacy</span> |{' '}
                          <span className="spanLink"
                                onClick={() => openInNewTab("https://autosure.co.nz/terms-of-use/")}>
            Terms of Use
        </span>
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div><img src={dplLogo} style={{ height: "inherit" }} alt="dplLogo" /></div>
                            {/*<div style={{ width: "2px", height: "100px", background: "#CCCCCC", margin: "0 10px" }}></div>*/}
                            {/*<div><img src={veroLogo} style={{width: "100px" }} alt="veroLogo" /></div>*/}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </>);
}

export default Footer;
